import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName, sortByKey } from '../utils'
import { loadCity, loadCountries, loadCourses, loadLanguages, loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

export default function SelectLanguage({ callback, placeholder, name="language", value, width , kurds=0 }) {

    const [SelectOptions, setSelectOptions] = useState([]);
    const customStyles = makeDarkSelectStyles({ width: width || '200px' });


    useEffect(() => {
        loadLanguages().then(languages => {            
            if (languages) {
                var temp_options = []
                languages.map((item, i) => {
                    var option = null;
                    option = {
                        label: item.name,
                        value: item.id
                    }
                   temp_options.push(option)
                })
                //
                setSelectOptions(temp_options);
                // callback()
                //setTalents(temp)
            }

        })
    }, [])

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder ? placeholder : "Languages"}
                    value={SelectOptions && SelectOptions.filter(obj => obj.value == value)}
                />
            </div>

        </>
    )
}
